<template>
  <element>
    <div class="customerMesg of">
      <div class="fl customerMesgL">
        <panel label="借贷人信息" style="padding:5px 0 5px 15px;">
          <form-build
            :form-data.sync="customerData"
            :form-columns="customerColumns"
            class="formTable"
          />
        </panel>
      </div>
      <div class="fr customerMesgR">
        <el-button type="primary" round class="checkReport" @click="getCustomerTongdun()">查询同盾信贷报告</el-button>
        <div class="customerMesgRresult of">
          <img src="../../assets/images/REVIEW.png" v-if="customerData.decision=='REVIEW'">
          <img src="../../assets/images/PASS.png" v-if="customerData.decision=='PASS'">
        </div>
      </div>
    </div>
    <div class="xzpadd10">
      <data-table
        :tableData="listData"
        :columns="tongdunColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
      ></data-table>
    </div>
    <!-- <el-row>
      <el-col :span="18">

      </el-col>
      <el-col :span="6">
        <panel class="zhengjianxinxi" style="margin-top:34px">
        </panel>
        <panel class="zhengjianxinxi" style="margin-top:34px">
        </panel>
      </el-col>
    </el-row> -->
  </element>
</template>


<script>
  import sexOptions from '../../utils/sexOptions'
  import {getImageUrl} from '../../filters/CommonActions'
  import Status2CN from "../../filters/Status2CN";
  import xhr from '../../utils/xhr'
  import moment from 'moment';
    export default {
        name: "CustomerTongdunComponent",
      data() {
        return {
          page: 1,
          pageSize: 10,
          filters:{},
          listData:{
            data: [],
            count: 0,
          },
          customerTongdunData:{},
          customerColumns: [
            {
              label: '借款人姓名',
              field: 'c__customerName',
              span:24
            },
            {
              label: '借款人手机',
              field: 'i__contactTelNo',
              span:24
            },
            {
              label: '借款人身份证',
              field: 'i__socialIdentityCode',
              span:24
            },
            {
              label: '最新报告时间',
              field: 'decisionDate',
              formatter: function(r,v) {
                if(v){
                  return moment(v).format('YYYY-MM-DD HH:mm:ss')
                }else{
                  return ''
                }

              },
              span:24
            },{
              label: '贷前反欺诈风险分',
              field: 'score',
              span:24
            },
          ],
          tongdunColumns: [
            {
              name: '序号',
              type: 'index',
              width:100,
            },
            {
              name: '风险描述',
              field: 'risk_name',
              align:'left',
              formatter: function (r,c,v) {
                return r.policy_name +':'+r.risk_name
              }

            },
          ],
        }
      },
      props: {
        value: {
          type: Object
        },
        isShowPic1: {
          Boolean,
          default: false
        }
      },
      computed: {
        customerData: {
          get: function () {
            return this.value
          },
          set: function (newVal) {
            this.$emit('input', newVal)
          }
        }
      },
      filters: {
        getImageUrl,
        sex2CN: function (sex) {
          let sexItem = sexOptions.filter(item=>item.value==sex).shift()||[]
          return sexItem.label||''
        },
      },
      watch : {
        'customerData.c__customerId' : function(newVal) {
          if(newVal) {
            this.getTongDun()
          }
        }
      },
      mounted() {
      /*    this.getTongDunList()
          this.getTongDunList()*/
      },
      methods:{
        getCustomerTongdun:function(){
          xhr.getCustomerTongdun(
            {
              'c.customerId': this.customerData.c__customerId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                //  alert( res.data.rflag.result.final_score)
                  this.customerData.decisionDate = Number(new Date());
                  this.customerData.score =res.data.rflag.result.final_score
                  this.customerData.decision =res.data.rflag.result.final_decision
                  this.listData = { data:res.data.rflag.result.risk_items,count:res.data.rflag.result.risk_items.length}
                  this.customerData = Object.assign({}, this.customerData)

                }

              }catch (e) {

              }
            }
          )

        },

        getTongDun: function() {

          xhr.getTongDun(
            {
              'c.customerId': this.customerData.c__customerId
            },
            res=>{
              try {
                if(res.data.status == 'success') {

                      let result =res.data.data.t__result

                      this.customerData.decisionDate = res.data.data.t__invokeTime;
                      this.customerData.score =result.final_score
                      this.customerData.decision =result.final_decision
                      this.customerData = Object.assign({}, this.customerData)

                      this.listData = { data:result.risk_items,count:result.risk_items.length}
                      console.log(this.listData)


                }
              }catch (e) {

              }
            }
          )
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerTongdunComponent.vue